module.exports = __webpack_public_path__ + "static/media/njit.60914499.png";